( function(){
  'use strict';

  angular.module('eclipseApp.checkout').controller('pickupAtStoreCtrl', ['$scope', 'buyService', function($scope, buyService){

    try {
      $scope.searchLocation = buyService.getServiceAddressDetails().$$state.value.address.postalCode;
    }
    catch(err){}

    $scope.$on('$viewContentLoaded', function(){
      // reset checkbox when switching from one tab to another
      $scope.fulfillment.agree = false;
      console.log('@pickupAtStoreCtrl:VIEWCONTENTLOADED');
    });
  }]);
})();
